/* eslint-disable jira/filename-case, jira/import/no-wildcard-imports */
import {
	UFOExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
} from '@atlassian/ufo/ufo-experimental';
import * as boardView from './pageSegmentLoad.tsx';
import * as collections from './loadViewCount.tsx';
import * as copyProjectConfiguration from './ExperienceCopyProjectConfiguration.tsx';
import * as deliveryItems from './loadAggregatedDeliveryProgress.tsx';
import * as fieldsSidebar from './fieldPlayCreate.tsx';
import * as formulaField from './precalculateFormulaFieldAllValuesSelector.tsx';
import * as globalFieldsAdministration from './loadGlobalFields.tsx';
import * as headerView from './viewGroupBy.tsx';
import * as ideaViewBentoSidebar from './ExperiencePageSegmentLoad.tsx';
import * as ideaView from './insightCreate.tsx';
import * as issues from './loadIssueJpdApi.tsx';
import * as listView from './ConstantsExperiencePageSegmentLoad.tsx';
import * as matrixView from './LibAnalyticsConstantsExperiencePageSegmentLoad.tsx';
import * as navBar from './changeViewName.tsx';
import * as noViewsScreen from './createView.tsx';
import * as playSidepanel from './updatePlayField.tsx';
import * as project from './pageLoadWithRateLimit.tsx';
import * as sharing from './loadSiteConfig.tsx';
import * as timelineView from './timelineDropExperience.tsx';
import * as viewPermissions from './loadViewAccess.tsx';
import * as view from './deleteView.tsx';
import * as connections from './connectionBetaConfigLoad.tsx';
import * as projectTemplateCreationAsync from './projectCreationPollingMarks.tsx';
import * as notification from './pageLoad.tsx';
import { createJpdExperience } from './createJpdExperience.tsx';
import type {
	ExperienceErrorReason,
	ExperienceMetadataExtra,
	JPDExperience,
} from './ExperienceMetadataExtra.types.tsx';

const issueTypesForProjectsLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.issue-types.load-all', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

const issueTypeCreate: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.issue-types.create', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

const issueTypeDelete: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.issue-types.delete', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

const issueTypeUpdate: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.issue-types.update', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

const issueTypePinnedFieldsUpdate: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.issue-types.pinned-fields.update', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

const issueTypePinnedFieldsLoad: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.issue-types.pinned-fields.load', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

const issueTypes: {
	issueTypeCreate: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra>;
	issueTypeUpdate: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra>;
	issueTypePinnedFieldsLoad: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra>;
	issueTypePinnedFieldsUpdate: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra>;
	issueTypeDelete: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra>;
	issueTypesForProjectsLoad: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra>;
} = {
	issueTypeCreate,
	issueTypeUpdate,
	issueTypePinnedFieldsLoad,
	issueTypePinnedFieldsUpdate,
	issueTypeDelete,
	issueTypesForProjectsLoad,
};

export const experience: {
	listView: typeof listView;
	formulaField: typeof formulaField;
	headerView: typeof headerView;
	boardView: typeof boardView;
	ideaView: typeof ideaView;
	ideaViewBentoSidebar: typeof ideaViewBentoSidebar;
	matrixView: typeof matrixView;
	navBar: typeof navBar;
	project: typeof project;
	timelineView: typeof timelineView;
	fieldsSidebar: typeof fieldsSidebar;
	issues: typeof issues;
	deliveryItems: typeof deliveryItems;
	sharing: typeof sharing;
	globalFieldsAdministration: typeof globalFieldsAdministration;
	playSidepanel: typeof playSidepanel;
	noViewsScreen: typeof noViewsScreen;
	view: typeof view;
	viewPermissions: typeof viewPermissions;
	collections: typeof collections;
	copyProjectConfiguration: typeof copyProjectConfiguration;
	connections: typeof connections;
	issueTypes: typeof issueTypes;
	projectTemplateCreationAsync: typeof projectTemplateCreationAsync;
	notification: typeof notification;
} = {
	listView,
	formulaField,
	headerView,
	boardView,
	ideaView,
	ideaViewBentoSidebar,
	matrixView,
	navBar,
	project,
	timelineView,
	fieldsSidebar,
	issues,
	deliveryItems,
	sharing,
	globalFieldsAdministration,
	playSidepanel,
	noViewsScreen,
	view,
	viewPermissions,
	collections,
	copyProjectConfiguration,
	connections,
	issueTypes,
	projectTemplateCreationAsync,
	notification,
};
